import { createSlice } from '@reduxjs/toolkit';
import { submitForm } from '../actions/formAction';

const initialState = {
  loading: false,
  error: null,
  success: false,
  forminfo: null,
};

const formSlice = createSlice({
  name: 'profileForm',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(submitForm.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(submitForm.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.forminfo = action.payload;
      })
      .addCase(submitForm.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default formSlice.reducer;
